document.addEventListener("DOMContentLoaded", function () {
  function addSparkAttribute() {
    const elements = document.getElementsByClassName(
      "kl-private-reset-css-Xuajs1"
    );
    for (let element of elements) {
      element.setAttribute("data-spark", "b2c-only");
      console.log("Added b2c-only attribute to:", element);
    }
  }

  addSparkAttribute();

  const observer = new MutationObserver(function (mutations) {
    addSparkAttribute();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
